export const columns = [
  {
      "name": "Name",
      "fieldName": "name",
      "columnName": "Name",
      "isSortable": true,
      "sortState": 0,
      "renderer": "text",
      "extra": null
  },
  {
      "name": "Modified",
      "fieldName": "dateLastModified",
      "columnName": "DateLastModified",
      "isSortable": true,
      "sortState": 2,
      "renderer": "simpleDate",
      "extra": null
  },
  {
      "name": "Created",
      "fieldName": "dateCreated",
      "columnName": "DateCreated",
      "isSortable": true,
      "sortState": 0,
      "renderer": "simpleDate",
      "extra": null
  },
  {
    "name": "Target Players",
    "fieldName": "organizations",
    "columnName": "TargetPlayers",
    "isSortable": false,
    "sortState": 0,
    "renderer": "usedBy",
    "extra": null
},
  {
      "name": "Organizations",
      "fieldName": "organizations",
      "columnName": "Organizations",
      "isSortable": false,
      "sortState": 0,
      "renderer": "usedBy",
      "extra": null
  },
  {
    "name": "Is Active",
    "fieldName": "isActive",
    "columnName": "IsActive",
    "isSortable": false,
    "sortState": 0,
    "renderer": "text",
    "extra": null
  },
]